import { useEffect } from "react";
import { Phone, Mail, MapPin, PhoneCall, CalendarCheck } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { ServiceRequestForm } from "@/components/ServiceRequestForm";
import { FadeIn } from "@/components/Reveal";
import { SITE } from "@/config/site";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact TSM Group CLE | Request a Service";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Request a service from TSM Group CLE — business risk management, compliance support, background screening, notary and document services throughout Northeast Ohio.");
  }, []);

  return (
    <div className="bg-paper" data-testid="contact-page">
      <PageHero
        testid="contact-hero"
        eyebrow="Contact"
        title={<>Talk with <span className="text-gold">TSM</span>.</>}
        copy="Tell us what your business needs. Our team reviews every request, confirms service details, and coordinates scheduling and next steps."
      >
        <div className="mt-10 grid gap-6 sm:grid-cols-3" data-testid="contact-hero-details">
          <a href={SITE.phoneHref} className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/5 p-4 transition-colors hover:border-gold/60" data-testid="contact-card-phone">
            <PhoneCall className="h-5 w-5 text-gold" />
            <span><span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-white/50">Phone</span><span className="text-sm font-bold">{SITE.phone}</span></span>
          </a>
          <a href={SITE.emailHref} className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/5 p-4 transition-colors hover:border-gold/60" data-testid="contact-card-email">
            <Mail className="h-5 w-5 text-gold" />
            <span><span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-white/50">Email</span><span className="text-sm font-bold">{SITE.email}</span></span>
          </a>
          <div className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/5 p-4" data-testid="contact-card-area">
            <MapPin className="h-5 w-5 text-gold" />
            <span><span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-white/50">Service Area</span><span className="text-sm font-bold">{SITE.serviceArea}</span></span>
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row">
          <a href={SITE.schedulingUrl} data-testid="contact-schedule-cta" className="btn-gold">
            <CalendarCheck className="h-4 w-4" />
            Schedule a Consultation
          </a>
          <a href={SITE.phoneHref} data-testid="contact-call-cta" className="btn-outline-light">
            <Phone className="h-4 w-4" />
            Call TSM Group CLE
          </a>
        </div>
        <p className="mt-5 text-xs text-white/45" data-testid="contact-consultation-note">
          Consultations are available for business risk management and operational discussions.
        </p>
      </PageHero>

      <ServiceRequestForm />
    </div>
  );
}
